module.exports = {
  content: {
    errorPhoneNumber: "Wrong format of phone number",
    successGetCode: "The verification code was successfully obtained",
    readAgree: "Please read and agree to the service agreement",
    successLogin: "Login successful",
    successRegister: "Registration success",
    collectionSuccess: "Collection success",
    cancelSuccess: "Cancel success",
    pleaseLogin: "Please sign in first",
    changeSuccess: "Modified successfully",
    phoneWrong: "The phone number format is wrong, please re-enter",
    unEmptyCode: "Verification code must be filled",
    codeText: "Get Code",
    cancelOrder: "Order canceled successfully",
    deleteOrder: "Order deleted successfully",
    confirmSuccessful: "Confirm successful receipt",
    pleaseSales: "Please select the products that need to apply for after-sales",
    sellerShip: "Seller has been reminded to ship",
    paymentSuccessful: "Payment successful!",
    cancelPayment: "Confirm to cancel payment?",
    questionDeleted: "Please select the question that needs to be deleted first",
    answerDeleted: "Please select the answer that needs to be deleted first",
    delSucccess: "Successfully deleted",
    pleaseContent: "Please enter content",
    successfulIntervention: "Successful application platform intervention",
    recordDeleted: "Please select the record to be deleted first",
    isJPG: "Upload pictures can only be in JPEG, JPG, PNG, BMP format!",
    isLt5M: "Upload image size cannot exceed 5MB!",
    submittedSuccessfully: "Submitted successfully",
    leastOneItem: "Please select at least one item",
    systemTips: "System tips",
    deleteProduct: "Are you sure you want to delete this product from your shopping cart?",
    cancel: "Cancel",
    confirm: "Confirm",
    info50: "There are too many items in your shopping cart. It is recommended that you delete some items before continuing",
    info100: "The total number of items in your shopping cart has reached the upper limit. Please clean up some and continue to add to the shopping cart.",
    cartEmptyTitle: "Opps, your shopping cart is empty!",
    cartEmptyContent: "Please browse the attractive products from the homepage.",
    shoppingNow: "Shopping Now",
    nostock: "Sorry, the product is out of stock, please select again.",
    offline: "Sorry, the product has been moved offline.",
    invalid: "This is an invalid product.",
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en-us/verify.js